<div [@routerTransition]>
    <sub-header [title]="('JournaVouchers' | localize) + ' ' + ('Details' | localize)"
                [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="journalHeader_PDate">{{ l('PDate') }}</label>

                            <abp-datetime-picker #journalHeader_date="ngModel" [(ngModel)]="journalHeader.journalDate"
                                                 id="journalHeader_date" name="journalHeader_date"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="journalHeader_date"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="journalHeader_ReferenceNo">{{ l('ReferenceNo') }}</label>
                            <input type="text" #journalHeader_ReferenceNo="ngModel" id="journalHeader_ReferenceNo"
                                   class="form-control" [(ngModel)]="journalHeader.referenceNo" name="ReferenceNo" />
                            <validation-messages [formCtrl]="journalHeader_ReferenceNo"></validation-messages>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="journalHeader_Description">{{ l('Description') }}</label>
                            <input type="text" #journalHeader_Description="ngModel" id="journalHeader_Description"
                                   class="form-control" [(ngModel)]="journalHeader.description" name="Description" />
                            <validation-messages [formCtrl]="journalHeader_Description"></validation-messages>
                        </div>
                    </div>

                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="10%">{{ l('Code') }}</th>
                                    <th width="30%">{{ l('Account') }}</th>
                                    <th width="8%">{{ l('Description') }}</th>
                                    <th width="8%">{{ l('Debit') }}</th>
                                    <th width="8%">{{ l('Credit') }}</th>
                                    <th width="5%">{{ l('Action') }}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let data of journalDetails; let i = index">
                                    <td class="text-center">
                                        <div class="d-flex align-items-center">
                                            <button class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    style="width: 30px; height: 30px" (click)="removeItem(i)">
                                                x
                                            </button>
                                            <span class="ps-1"><b>{{ data.slNo }}</b></span>
                                        </div>
                                        <!-- (click)="removeItem(i)" -->
                                    </td>
                                    <td> <input type="text" #itemCodeInput class="form-control" [(ngModel)]="data.accountCode" (keydown.enter)="searchAccount(data.accountCode,data,i)" (blur)="searchAccount(data.accountCode,data,i)" /> </td>
                                    <td>
                                        <select id="das" [(ngModel)]="data.accountId"
                                                (change)="getAccountCode($event,data,i)"
                                                class="form-select">
                                            <option value="0">{{ l('SelectAccount') }}</option>

                                            <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="text" #journalHeader_ReferenceNo="ngModel" id="journalHeader_ReferenceNo"
                                               class="form-control" #descriptionInputs (keydown.enter)="focusNext('debit', i)" [(ngModel)]="data.description" name="ReferenceNo" />
                                    </td>
                                    <td><input type="text" #debitInputs (keydown.enter)="focusNext('credit', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.debit" (ngModelChange)="calculateTotalValues()" /></td>
                                    <td><input type="text" #creditInputs (keydown.enter)="focusNext('add', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.credit" (ngModelChange)="calculateTotalValues()" /></td>
                                    <td width="5%" class="text-center">
                                        <button #addButton (keydown.enter)="focusNext('nextRow', i)" class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                style="width: 30px; height: 30px" (click)="addRow(i)">
                                            +
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table>
                            <tr>
                                <td width="80%" style="vertical-align: top">
                                   
                                </td>
                                <td width="20%" style="vertical-align: top">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="journalHeader_PDebit">{{ l('Debit') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="journalHeader_PDebit" class="form-control text-end"
                                                       [(ngModel)]="this.journalHeader.debit" name="PDebit" />

                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="journalHeader_Credit">{{ l('Credit') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="journalHeader_Credit" class="form-control text-end"
                                                       [(ngModel)]="this.journalHeader.credit" name="Credit" />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save()"
                            class="btn btn-primary blue float-right" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
